import {Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import {ShipmentReviewService} from 'src/app/services/shipment-review/shipment-review.service';
import {AgGridAngular} from "ag-grid-angular";
import {AsyncPipe, NgIf, DatePipe} from "@angular/common";
import { BehaviorSubject, takeWhile } from 'rxjs';
import { ColDef, ColGroupDef, DomLayoutType } from 'ag-grid-enterprise';
import AppConstants from 'src/app/shared/common-components/AppConstants';
import { frtshipmentreview } from 'src/app/shared/common-components/common-structure';
@Component({
    selector: 'frt-shipment-comprehensive-report',
    imports: [
        AgGridAngular
    ],
    templateUrl: './frt-shipment-comprehensive-report.component.html',
    styleUrls: ['./frt-shipment-comprehensive-report.component.css']
})
export class FrtShipmentComprehensiveReportComponent implements OnInit, OnDestroy {
  private observer$ = new BehaviorSubject(true);
  carrierID: number;
  agencyMasterID: number;
  endDate: number;
  beginDate: number;
  columnDefs:  (ColDef | ColGroupDef)[];
  frtShipmentComprehensiveReport: frtshipmentreview[];
  domLayout: DomLayoutType;
  itemsPerPage:number = 20;

  ngOnInit(): void {
    this.carrierID = Number(this.route.snapshot.queryParamMap.get('carrierID'));
    this.agencyMasterID = Number(this.route.snapshot.queryParamMap.get('agencyMasterID'));
    this.endDate = Number(this.route.snapshot.queryParamMap.get('endDate'));
    this.beginDate = this.route.snapshot.queryParamMap.get('beginDate') === "0" ? 0 : Number(this.route.snapshot.queryParamMap.get('beginDate'));
    this.domLayout = 'autoHeight';
    console.log(this.carrierID);
    this.getShipmentsBasedOnCarrierID();
    this.columnDefs = this.genrateColDefForFRTShipmentComprehensiveReport();
  }

  constructor( private route: ActivatedRoute,
              private shipmentReviewService: ShipmentReviewService,
              private datepipe: DatePipe
  ) { }

  getShipmentsBasedOnCarrierID(){
    this.shipmentReviewService.getFRTShipmentForComprehensiveReport( this.carrierID, this.beginDate, this.endDate, this.agencyMasterID)
    .pipe(takeWhile(() => this.observer$.value))
    .subscribe({
        next: (data: any) => {
          this.frtShipmentComprehensiveReport = data;
        },
        error(err) {
          console.log(err)
        },
      }
  );
  
  }

 genrateColDefForFRTShipmentComprehensiveReport(){
    return [
      <ColDef>
        {
          headerName: 'Shipment ID',
          field: 'shipmentId',
          filter: 'agNumberColumnFilter',
          width: 100,
        },
      {
        headerName: 'BOL Number',
        field: 'bolNumber',
        width: 100,
        filter: 'agTextColumnFilter',
      },
      // agencyShipmentIdNo
      {
        headerName: 'Agency Shipment Id',
        field: 'agencyShipmentIdNo',
        width: 100,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'TSP Name',
        field: 'carrierName',
        width: 250,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Agency-Bureau Name',
        field: 'agencyBureauName',
        filter: 'agTextColumnFilter',
        width: 100
      },
      {
        headerName: 'Origin',
        field: 'origin',
        cellRenderer: (params: { data: { originCity: string; originState: string; originZip: string; originCountry: string; }; }) => {
          return params.data.originCity  + ' ' + params.data.originState + ', ' + params.data.originZip + ', '+ params.data.originCountry;
        },
        width: 250,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Destination',
        field: 'destination',
        cellRenderer: (params: { data: { destCity: string; destState: string; destZip: string; destContry: string; }; }) => {
          return params.data.destCity  + ' ' + params.data.destState + ', ' + params.data.destZip + ', '+ params.data.destContry;
        },
        width: 250,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Move Date',
        field: 'moveDate',
        cellRenderer: (params: { data: { moveDate: string; }; }) => {
          return (AppConstants.isNotNullCondition(params.data.moveDate)) ?
          this.datepipe.transform(params.data.moveDate, 'yyyy-MM-dd')  : 'Not Available';
        },
        width: 120,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Status',
        width: 130,
        field: 'bookingStatus',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Total Cost',
        width: 90,
        field: 'totalCost',
        filter: 'agTextColumnFilter',
        headerTooltip: 'Total Cost includes Fuel Surcharge and Accessorials Cost',
        valueFormatter: this.shipmentReviewService.formatNumber

      },
      {
        headerName: 'Fuel SRCHG',
        width: 90,
        field: 'fuelSurchargeCost',
        filter: 'agTextColumnFilter',
        valueFormatter: this.shipmentReviewService.formatNumber
      },
      {
        headerName: 'IFF Calculated',
        width: 90,
        field: 'estimatedIffDue',
        filter: 'agTextColumnFilter',
        headerTooltip: 'IFF does not include Fuel Surcharge Cost' ,
        valueFormatter: this.shipmentReviewService.formatNumber

      },
      {
        headerName: 'Weight',
        width: 90,
        field: 'weight',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Miles',
        width: 90,
        field: 'miles',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'OTO',
        field: 'oneTimeOnly',
        width: 80,
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'Actual Delivery Date',
        field: 'actualDeliveryDate',
        cellRenderer: (params: { data: { actualDeliveryDate: string; }; }) => {
          return (AppConstants.isNotNullCondition(params.data.actualDeliveryDate)) ?
          this.datepipe.transform(params.data.actualDeliveryDate, 'yyyy-MM-dd')  : 'Not Available';
        },
        width: 120,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Sent To Syncada',
        field: 'sentToSyncada',
        width: 100,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Date Sent to Syncada',
        field: 'dateSentToSyncada',
        cellRenderer: (params: { data: { dateSentToSyncada: string; }; }) => {
          return (AppConstants.isNotNullCondition(params.data.dateSentToSyncada)) ?
          this.datepipe.transform(params.data.dateSentToSyncada, 'yyyy-MM-dd')  : 'Not Available';
        },
        width: 120,
        filter: 'agDateColumnFilter'
      },
      {
        headerName: 'Smart Way',
        field: 'smartWayScore',
        filter: 'agTextColumnFilter',
        minWidth: 80,
        maxWidth: 100,
        cellRenderer: params =>
          params.data.smartWayScore === 1
            ? '<svg class="usa-icon define-text-green define-size-leaf" aria-hidden="true" focusable="false" role="img"><use xlink:href="/assets/uswds/img/sprite.svg#eco"></use></svg>'
            : ''
      }, {
        headerName: 'Socio Econ Ind',
        field: 'ses',
        filter: 'agTextColumnFilter'
      }, {
        headerName: 'Mode',
        field: 'mode',
        filter: 'agTextColumnFilter'
      }
      
    ];
 }

  ngOnDestroy() {
    this.observer$.next(false);
    // throw new Error('Method not implemented.');
  }
}
